export enum OptimizedOption {
  OPTIMIZED = 'optimized',
  NONE = 'none',
}

export enum OnOffOption {
  ON = 'on',
  OFF = 'off',
}

export enum AccessOption {
  ALL = 'all',
  RESTRICTED = 'restricted',
  UNRESTRICTED = 'unrestricted',
}
